import React from 'react';
import { Modal, Typography, Button } from 'antd';
import useKeypress from 'react-use-keypress';

const { Text } = Typography;

const styles = {
  modalTitle: {
    fontSize: '16px',
    fontWeight: 500,
    color: '#fff'  // Ant Design's primary text color
  },
  modalContent: {
    padding: '32px 24px'
  },
  gridContainer: {
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    gap: '16px',
    alignItems: 'center'
  },
  baseText: {
    fontSize: '15px',
    lineHeight: '24px',
    color: '#fff',
    justifySelf: 'start'
  },
  valueText: {
    color: '#1890ff',  // Ant Design's primary blue
    fontSize: '18px',
    fontWeight: 600,
    justifySelf: 'end'
  },
  modal: {
    borderRadius: '8px',
    overflow: 'hidden',
    marginTop: '5px',
    position: 'absolute',
    right: '0',
    top: '0',
    margin: '20px'
  }
};

export const NetUnitPriceModal = ({
  isVisible,
  onConfirm,
  onCancel,
  calculatedValues = {}  // { nonLiner: number, liner?: number }
}) => {
  // Check if any calculated values are negative
  const hasNegativeValues = 
    (calculatedValues.nonLiner && Number(calculatedValues.nonLiner) < 0) ||
    (calculatedValues.liner && Number(calculatedValues.liner) < 0);

  // Create footer buttons based on whether values are negative
  const footerButtons = [
    <Button key="cancel" size="large" onClick={onCancel}>
      Cancel
    </Button>
  ];

  // Only add OK button if no negative values
  if (!hasNegativeValues) {
    footerButtons.push(
      <Button key="confirm" type="primary" size="large" onClick={onConfirm}>
        Confirm
      </Button>
    );
  }

  useKeypress(['Enter'], (event) => {
    if (event.altKey) {
      if (isVisible && !hasNegativeValues) {
        event.preventDefault();
        onConfirm();
      }
    }
  });

  return (
    <Modal
      title={<span style={styles.modalTitle}>Net Unit Price Confirmation</span>}
      open={isVisible}
      onCancel={onCancel}
      footer={footerButtons}
      width={440}
      style={styles.modal}
      styles={{ backgroundColor: 'rgba(0, 0, 0, 0.45)' }}
      wrapClassName="right-side-modal"
    >
    <div style={styles.modalContent}>
      <div style={styles.gridContainer}>
        {
          calculatedValues.nonLiner && (
            <>
              <Text style={styles.baseText}>Net Unit Price Non Liner:</Text>
              <Text style={styles.valueText}>{Number(calculatedValues.nonLiner).toFixed(2)}</Text>
            </>
          )
        }

        {calculatedValues.liner && (
          <>
            <Text style={styles.baseText}>Net Unit Price Liner:</Text>
            <Text style={styles.valueText}>{Number(calculatedValues.liner).toFixed(2)}</Text>
          </>
        )}
      </div>
      
      {hasNegativeValues && (
        <div style={{ 
          marginTop: '20px', 
          padding: '12px', 
          // backgroundColor: '#fff2e8', 
          border: '1px solid #ffbb96', 
          borderRadius: '6px' 
        }}>
          <Text style={{ 
            color: '#fff2e8', 
          }}>
            ⚠️ Negative value detected. Please fix the block entry before proceeding.
          </Text>
        </div>
      )}
    </div>
  </Modal>
  );
};
